import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {
  AddUserAckDetails,
  UserAckResponse,
} from '../../app/models/UserAckDetails.model';
import { map } from 'rxjs';
import { DeactivateDetails } from '../../app/models/UserDeactivate.model';
import { FeedbackDetails } from '../../app/models/FeedbackDetails.model';
import { API_BASE_URL } from './../environments/environments.module';

@Injectable({
  providedIn: 'root',
})
export class PopupTriggerService {
  baseurl: any;

  // private apiURL = " /api/BWTEmployeeFunctionApp/";

  constructor(
    private httpClient: HttpClient,
    @Inject(API_BASE_URL) API_BASE_URL: any,
  ) {
    this.baseurl = API_BASE_URL.employeeInfo;
  }

  private popupRequested = new BehaviorSubject<boolean>(false);
  popupRequested$ = this.popupRequested.asObservable();

  requestPopup() {
    this.popupRequested.next(true);
  }

  consumePopupRequest(): boolean {
    const shouldShow = this.popupRequested.value;
    this.popupRequested.next(false);
    return shouldShow;
  }

  AddUserAckDetails(AddUserAckDetails: AddUserAckDetails) {
    return this.httpClient.post<any>(
      this.baseurl + 'AddUserAckDetails',
      AddUserAckDetails,
    );
  }

  DeactivateUserkDetails(DeactivateDetails: DeactivateDetails) {
    return this.httpClient.post<any>(
      this.baseurl + 'DeactivateUser',
      DeactivateDetails,
    );
  }

  GetUserAckDetails(EnterpriseId: string): Observable<boolean> {
    return this.httpClient
      .post<UserAckResponse>(this.baseurl + 'GetUserAckDetails', {
        EnterpriseId: EnterpriseId,
      })
      .pipe(
        map((response?: UserAckResponse) => {
          // console.log('GetUserAckDetails API response:', response);

          if (
            response?.IsSuccess &&
            response?.MessageBody?.DisclaimerAcknowledged
          ) {
            return true;
          } else {
            return false;
          }
        }),
      );
  }

  SaveFeedbackDetails(FeedbackDetails: FeedbackDetails) {
    return this.httpClient.post<any>(
      this.baseurl + 'SaveFeedbackDetails',
      FeedbackDetails,
    );
  }
}
